import { useSelector } from 'react-redux';
import React, { FC, useState } from 'react';
import { AreaOption } from '../../types';
import { RootState } from '../../../../store/reducers';
import FW from '../../../../config/word.json';

export interface KeywordSearchProps {
  areaOptions: AreaOption[];
  onSearch: (params: { area: string; keyword: string }) => void;
}

const KeywordSearch: FC<KeywordSearchProps> = ({ areaOptions, onSearch }) => {
  const { loading } = useSelector((state: RootState) => state.shopList);
  const [area, setArea] = useState('');
  const [keyword, setKeyword] = useState('');

  const handleSearch = () => {
    onSearch({ area, keyword });
  };

  return (
    <div className="p-content-area__column p-content-area__column--sp-width330 u-gap15">
      <div className="c-select c-select--x-large">
        <select name="store" className="c-select__window" value={area} onChange={(e) => setArea(e.target.value)}>
          <option value="">エリアから検索</option>
          {areaOptions.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      </div>

      <div className="c-input c-input--x-large">
        <input
          className="c-input__window"
          type="text"
          placeholder="店舗名・住所で検索"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </div>

      <button type="button" className="c-button c-button--primary c-button--large" onClick={handleSearch}>
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            {FW.F_W_LOADING}
          </>
        ) : (
          <>検索する</>
        )}
      </button>
    </div>
  );
};

export default KeywordSearch;
